module.exports = __webpack_public_path__ + "static/media/6.748e12f4.jpg";